import { Component, Input } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { StorePage } from 'src/app/pages/store/store.page';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { environment } from 'src/environments/environment';
import { WebBlocker } from '../../decorators/web-blocker.decorator';

@Component({
  selector: 'app-superlike-modal',
  templateUrl: './superlike-modal.component.html',
  styleUrls: ['./superlike-modal.component.scss'],
})
export class SuperLikeModalComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() userData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() theSoul: any;
  @Input() srcIconSuperLike: string = 'assets/imgs/orangeStar.svg';

  readonly priceSuperLike: number = environment.priceSuperLike ?? 1;

  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private analytics: AnalyticsService,
  ) {}

  get soulName(): string {
    return this.theSoul?.firstName != null ? this.theSoul.firstName : '';
  }

  get hasEnoughCoins(): boolean {
    return (this.userData?.coins ?? 0) >= this.priceSuperLike;
  }

  get descriptionText(): string {
    return this.translate.instant('increaseChancesSuperLike', {
      name: this.soulName,
      coin: this.translate.instant('coin'),
    });
  }

  dismiss() {
    this.modalCtrl.dismiss('cancelled');
  }

  confirmSend() {
    this.analytics.registerEvent(AnalyticsService.superLikeEvent);
    console.log('! Analytics "superLike" event sent !');
    this.modalCtrl.dismiss('confirmed');
  }

  @WebBlocker()
  async openCurrency(origin: string) {
    const modal = this.modalCtrl.create({
      component: StorePage,
      componentProps: { me: this.userData, type: 'carrot', origin: origin },
    });
    this.analytics.registerEvent(AnalyticsService.carrots);
    this.analytics.registerEvent(AnalyticsService.crrtFromSuperlike);
    (await modal).present();

    (await modal).onDidDismiss().then(async () => {
      const stored = await Preferences.get({ key: 'USER_DATA' });
      if (stored?.value && this.userData) {
        const updated = JSON.parse(stored.value);
        this.userData.coins = updated.coins;
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onImageError(event: any) {
    console.error('Erro ao carregar imagem:', this.srcIconSuperLike);
    console.error('Evento de erro:', event);
  }
}
